import axios from 'axios'

const apiClient = axios.create({
  baseURL: `${process.env.VUE_APP_API_URL}`,
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-type': 'application/json'
  },
  timeout: 10000 //Throw error if API call takes longer than 10 sec//
})

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.authorization = 'Bearer '+ token;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

export default {
  // services for PRODUCT //
  getProducts() {
    return apiClient.get('/products') //API call that fetch all products in json object//
  },
  searchProducts(searchTerm) {
    return apiClient.get(`/search/products?search=${searchTerm}`) //API call that fetch all products in json object//
  },
  getProduct(id) {
    return apiClient.get('/products/' + id) // API call to tell server which product to fetch//
  },
  postProduct(product) {
    return apiClient.post('/products', product)
  },
  updateProduct(product) {
    return apiClient.put('/product/' + product.id, product)
  },
  deleteAllProducts() {
    return apiClient.delete('/products') //API call that fetch all products in json object//
  },
  deleteProduct(id) {
    return apiClient.delete('/products/' + id) // API call to tell server which product to fetch//
  },
  // services for UNIT //
  getUnits() {
    return apiClient.get('/units') //API call that fetch all units in json object//
  },
  searchUnits(searchTerm) {
    return apiClient.get(`/search/units?search=${searchTerm}`) //API call that fetch all products in json object//
  },
  getUnit(id) {
    return apiClient.get('/unit/' + id) // API call to tell server which unit to fetch//
  },
  postUnit(unit) {
    //apiClient.defaults.headers = `${localStorage.getItem('token')}`
    return apiClient.post('/units', unit)
  },
  deleteUnits() {
    return apiClient.delete('/units') //API call that fetch all products in json object//
  },
  deleteUnit(id) {
    return apiClient.delete('/unit/' + id) // API call to tell server which product to fetch//
  },
  updateUnit(unit) {
    return apiClient.put('/unit/' + unit.id, unit)
  },
  // services for PRODUCT CATEGORY //
  getProductCategory(id) {
    return apiClient.get('/productCategories/' + id) // API call to tell server which product to fetch//
  },
  getProductCategories() {
    return apiClient.get('/productCategories') //API call that fetch all product categories in json object//
  },
  deleteProductCategories() {
    return apiClient.delete('/productCategories') //API call that fetch all products in json object//
  },
  deleteProductCategory(id) {
    return apiClient.delete('/productCategories/' + id) // API call to tell server which product to fetch//
  },
  updateProductCategory(productCategory) {
    return apiClient.put('/productCategory/' + productCategory.id, productCategory)
  },
  getProductCategoryNames() {
    return apiClient.get('/productCategoryNames') //API call that fetch all product category names in json object//
  },
  postProductCategory(productCategory) {
    return apiClient.post('/productCategories', productCategory)
  },
  //! services for UNIT PRODUCT //
  getUnitProducts(id) {
    return apiClient.get('/unitProducts/' + id) //API call that fetch all product categories in json object//
  },
  searchUnitProducts(id, searchTerm) {
    return apiClient.get(`/search/unitProducts/${id}?search=${searchTerm}`) //API call that fetch all products in json object//
  },
  getUnitProduct(unitId, productId) {
    return apiClient.get('/unit/' + unitId + '/product/' + productId) // API call to tell server which product to fetch//
  },
  postUnitProduct(unitProduct) {
    return apiClient.post('/unitProducts', unitProduct)
  },
  updateUnitProduct(unitProduct) {
    return apiClient.put('/unitProduct', unitProduct)
  },
  updateUnitProductStock(unitProduct) {
    return apiClient.post(`/restock/unit/${unitProduct.unit_id}/product/${unitProduct.product_id}`, unitProduct)
  },
  deleteUnitProducts() {
    return apiClient.delete('/unitProducts') //API call that fetch all products in json object//
  },
  deleteUnitProduct(unitId, productId) {
    return apiClient.delete(`/unitProducts/unit/${unitId}/product/${productId}`) // API call to tell server which product to fetch//
  },

  // services for CLAIM //
  getClaims() {
    return apiClient.get('/claims') //API call that fetch all claims in json object//
  },
  getClaim(id) {
    return apiClient.get('/claims/' + id) // API call to tell server which claim to fetch//
  },
  postClaim(claim) {
    return apiClient.post('/claims', claim)
  },
  deleteClaims() {
    return apiClient.delete('/claims') //API call that fetch all products in json object//
  },
  deleteClaim(id) {
    return apiClient.delete('/claims/' + id) // API call to tell server which product to fetch//
  },
    // services for SUPPLIER //
  getSuppliers() {
    return apiClient.get('/suppliers') //API call that fetch all suppliers in json object//
  },
  getSupplier(id) {
    return apiClient.get('/suppliers/' + id) // API call to tell server which supplier to fetch//
  },
  postSupplier(supplier) {
    return apiClient.post('/suppliers', supplier)
  },
  deleteSuppliers() {
    return apiClient.delete('/suppliers') //API call that fetch all products in json object//
  },
  deleteSupplier(id) {
    return apiClient.delete('/suppliers/' + id) // API call to tell server which product to fetch//
  },
  editSupplier(supplier) {
    return apiClient.put('/supplier/' + supplier.id, supplier)
  },
  addClientShippingDetail(shippingDetails) {
    return apiClient.post('/product/shippingDetails', shippingDetails)
  },
  addProductWholesaleDetail(wholesaleDetails) {
    return apiClient.post('/product/wholesaleDetails', wholesaleDetails)
  },
  getLowstockUnitProducts() {
    return apiClient.get('/lowStock/unitProduct') //API call that fetch all product categories in json object//
  },
  getProductStock() {
    return apiClient.get('/product/stock') //API call that fetch all products in json object//
  },
  searchProductStock(searchTerm) {
    return apiClient.get(`/search/product/stock?search=${searchTerm}`)
  },
  getUnitInventoryStock() {
    return apiClient.get('/unitInventory/stock') //API call that fetch all products in json object//
  },
  saveProductVideoUrl(videoData) {
    return apiClient.post('/save/video/url', videoData)
  },
  convertTextToImage(textJson) {
    return apiClient.post(`/text-to-image`, textJson)
  },
  copyUnitProductImage(copyJson) {
    return apiClient.post(`/copy/image/product/unitProduct`, copyJson)
  },
  getUnitProductsToRestock(unitId) {
    return apiClient.get(`/restock/products/list/${unitId}`)
  },
  markInventoryActivity(body) {
    return apiClient.post('/inventory/activity', body)
  }
}
